import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import {getModelForResourceType} from 'resources/modelRegistry';
import ArrayToReadableFragment from 'lib/hocs/arrayToReadableFragment';
import {Banner, Button} from '@albert-io/atomic';

import './classroom-invite-banner.scss';

const ClassroomInviteBanner = ({className, disabled, onClick, invitation, ...rest}) => {
  const salutationsAndNamesArr = [
    ...invitation
      .getClassroom()
      .getTeachers()
      .map((teacher) => `${teacher.getSalutation()} ${teacher.getLastName()}`)
  ];
  return (
    <Banner className={classnames('invite-banner u-width_100pc', className)} {...rest}>
      <div className='invite-banner__inner u-width_100pc flex'>
        <div className='u-mar-r_auto flex'>
          <Banner.Icon className='self-center' icon={['far', 'envelope']} />
          <span className='self-center'>
            You have been invited to <b>{invitation.getClassroom().getName()}</b> with{' '}
            <ArrayToReadableFragment arr={salutationsAndNamesArr} as='b' />
          </span>
        </div>
        <Button
          className='invite-banner__btn self-center'
          disabled={disabled}
          onClick={onClick}
          size='s'
        >
          Accept
        </Button>
      </div>
    </Banner>
  );
};

ClassroomInviteBanner.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  invitation: PropTypes.instanceOf(getModelForResourceType('classroom_invitation_v1')),
  onClick: PropTypes.func
};

export default ClassroomInviteBanner;
